import type { RoomThermostatWidget } from '../../../widgets';
import {
  BindingRow,
  CheckboxField,
  NumberField,
  OptionalBindingRow,
  Row,
  Section,
  TextField,
  patcher,
  rangeError,
  stepError,
  type WidgetEditorProps,
} from '../fields';
import { AiHintSection } from './AiHintSection';

export function RoomThermostatEditor(
  { widget, plantId, missing, onChange }: WidgetEditorProps<RoomThermostatWidget>,
) {
  const patch = patcher(widget, onChange);
  const range = rangeError(widget.setpointMin, widget.setpointMax);
  return (
    <>
      <Section title="Raum">
        <TextField
          label="Name des Raums"
          value={widget.roomName}
          keepEmptyString
          required
          missing={missing.has('roomName')}
          placeholder="Wohnzimmer"
          onChange={(next) => patch({ roomName: next ?? '' })}
        />
        <BindingRow
          label="Raumtemperatur"
          value={widget.roomTemperaturePoint}
          plantId={plantId}
          filter={{ valueType: 'number' }}
          onChange={(next) => patch({ roomTemperaturePoint: next })}
        />
      </Section>

      <Section title="Sollwert">
        <BindingRow
          label="Sollwert"
          value={widget.setpointPoint}
          plantId={plantId}
          filter={{ valueType: 'number', writable: widget.setpointWritable !== false }}
          onChange={(next) => patch({ setpointPoint: next })}
        />
        <CheckboxField
          label="Sollwert verstellbar"
          checked={widget.setpointWritable !== false}
          onChange={(next) => patch({ setpointWritable: next })}
        />
        <Row>
          <NumberField
            label="Unten"
            value={widget.setpointMin}
            error={range}
            onChange={(next) => patch({ setpointMin: next })}
          />
          <NumberField
            label="Oben"
            value={widget.setpointMax}
            error={range ? ' ' : undefined}
            onChange={(next) => patch({ setpointMax: next })}
          />
          <NumberField
            label="Schrittweite"
            value={widget.setpointStep}
            min={0}
            error={stepError(widget.setpointStep)}
            onChange={(next) => patch({ setpointStep: next })}
          />
        </Row>
      </Section>

      <Section title="Umfeld">
        <OptionalBindingRow
          label="Betriebsart"
          value={widget.modePoint}
          plantId={plantId}
          filter={{ valueType: 'enum' }}
          hint="Komfort, Standby, Abwesend, Frostschutz."
          onChange={(next) => patch({ modePoint: next })}
        />
        <OptionalBindingRow
          label="Feuchte"
          value={widget.humidityPoint}
          plantId={plantId}
          filter={{ valueType: 'number' }}
          onChange={(next) => patch({ humidityPoint: next })}
        />
        <OptionalBindingRow
          label="Fensterkontakt"
          value={widget.windowContactPoint}
          plantId={plantId}
          hint="Bei offenem Fenster graut die Kachel die Verstellung aus."
          onChange={(next) => patch({ windowContactPoint: next })}
        />
        <OptionalBindingRow
          label="Präsenz"
          value={widget.presencePoint}
          plantId={plantId}
          hint="Erklärt dem Bediener, warum der Sollwert gesprungen ist."
          onChange={(next) => patch({ presencePoint: next })}
        />
      </Section>

      <AiHintSection value={widget.ai} onChange={(next) => patch({ ai: next })} />
    </>
  );
}
